export const APPOINTMENT_DATE_SELECTED = 'APPOINTMENT_DATE_SELECTED';
export const APPOINTMENT_SCHEDULE_RANGE_SELECTED = 'APPOINTMENT_SCHEDULE_RANGE_SELECTED';
export const APPOINTMENT_DATA_ERROR = 'APPOINTMENT_DATA_ERROR';
export const STORE_APPOINTMENT_DATA_SUCCESS = 'STORE_APPOINTMENT_DATA_SUCCESS';
export const CLEAN_APPOINTMENT_STORE = 'CLEAN_APPOINTMENT_STORE';
export const STORE_ADDRESS_FORM_VALUES_SUCCESS = 'STORE_ADDRESS_FORM_VALUES_SUCCESS';
export const GEOLOCATE_ADDRESS_SUCCESS = 'GEOLOCATE_ADDRESS_SUCCESS';
export const GET_ADVISORS_SUCCESS = 'GET_ADVISORS_SUCCESS';
export const GET_ADVISORS_HOURS_SUCCESS = 'GET_ADVISORS_HOURS_SUCCESS';
export const GET_EMPTY_DATES_SUCCESS = 'GET_EMPTY_DATES_SUCCESS';
export const CLEAN_ADVISOR_STORE = 'CLEAN_ADVISOR_STORE';
export const STORE_WORKSHOP_LATLNG = 'STORE_WORKSHOP_LATLNG';
export const SET_SELECTED_DATE_AND_TIME = 'SET_SELECTED_DATE_AND_TIME';
export const SET_BEFORE_BUDGET = 'SET_BEFORE_BUDGET';
export const STORE_PICKUP_ADDRESS = 'STORE_PICKUP_ADDRESS';
export const PERSIST_DATEPICKERUI_VALUES = 'PERSIST_DATEPICKERUI_VALUES';
export const LOAD_INITIALS_DATEPICKERUI_VALUES = 'LOAD_INITIALS_DATEPICKERUI_VALUES';
export const ADD_REPLACEMENT_VEHICLE = 'ADD_REPLACEMENT_VEHICLE';
export const REMOVE_REPLACEMENT_VEHICLE = 'REMOVE_REPLACEMENT_VEHICLE';


// WEBPACK FOOTER //
// ./src/workflow/checkout/appointment/types.js